import {
  concat,
  filter,
  uniq
} from 'lodash'

import urls from '../constants/urls'

export const FAVOURITES_LOAD_FAILED = 'favouriteNumbers/FAVOURITES_LOAD_FAILED'
export const FAVOURITES_LOAD_SUCCESS = 'favouriteNumbers/FAVOURITES_LOAD_SUCCESS'
export const LOADING_FAVOURITES = 'favouriteNumbers/LOADING_FAVOURITES'

export const FAVOURITING_NUMBER = 'favouriteNumbers/FAVOURITING_NUMBER'
export const NUMBER_FAVOURITING_FAILED = 'favouriteNumbers/NUMBER_FAVOURITING_FAILED'
export const NUMBER_FAVOURITING_SUCCESS = 'favouriteNumbers/NUMBER_FAVOURITING_SUCCESS'

export const NUMBER_UNFAVOURITING_FAILED = 'favouriteNumbers/NUMBER_UNFAVOURITING_FAILED'
export const NUMBER_UNFAVOURITING_SUCCESS = 'favouriteNumbers/NUMBER_UNFAVOURITING_SUCCESS'
export const UNFAVOURITING_NUMBER = 'favouriteNumbers/UNFAVOURITING_NUMBER'

const initialState = {
  numbers: [],

  failedLoading: false,

  hasLoaded: false,

  isLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_FAVOURITES:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case FAVOURITES_LOAD_SUCCESS:
      return {
        ...state,
        numbers:       action.payload.data,
        total:         action.payload.headers['x-total'],
        isLoading:     false,
        failedLoading: false,
        hasLoaded:     true
      }

    case FAVOURITES_LOAD_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    case FAVOURITING_NUMBER:
      return {
        ...state,
        isFavouriting:     true,
        failedFavouriting: false
      }

    case NUMBER_FAVOURITING_SUCCESS:
      return {
        ...state,
        numbers:       uniq(concat(state.numbers, [action.meta.previousAction.number])),
        isFavouriting: false
      }

    case NUMBER_FAVOURITING_FAILED:
      return {
        ...state,
        isFavouriting:     false,
        failedFavouriting: true
      }

    case UNFAVOURITING_NUMBER:
      return {
        ...state,
        isUnfavouriting:     true,
        failedUnfavouriting: false
      }

    case NUMBER_UNFAVOURITING_SUCCESS:
      let unfavouritedNumber = action.meta.previousAction.number

      const newNumbers = filter(state.numbers, number => number.id !== unfavouritedNumber.id)

      return {
        ...state,
        numbers:         newNumbers,
        isUnfavouriting: false
      }

    case NUMBER_UNFAVOURITING_FAILED:
      return {
        ...state,
        isUnfavouriting:     false,
        failedUnfavouriting: true
      }

    default:
      return state
  }
}

export const loadFavourites = (hospital) => (dispatch) => {
  return dispatch({
    types:   [LOADING_FAVOURITES, FAVOURITES_LOAD_SUCCESS, FAVOURITES_LOAD_FAILED],
    payload: {
      request: {
        url: urls.hospitals.favouriteNumbers.index(hospital.id)
      }
    }
  })
}

export const favouriteNumber = (hospital, number) => (dispatch) => {
  return dispatch({
    types:   [FAVOURITING_NUMBER, NUMBER_FAVOURITING_SUCCESS, NUMBER_FAVOURITING_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.hospitals.favouriteNumbers.create(hospital.id, number.id)
      }
    },
    number
  })
}

export const unfavouriteNumber = (hospital, number) => (dispatch) => {
  return dispatch({
    types:   [UNFAVOURITING_NUMBER, NUMBER_UNFAVOURITING_SUCCESS, NUMBER_UNFAVOURITING_FAILED],
    payload: {
      request: {
        method: 'delete',
        url:    urls.hospitals.favouriteNumbers.destroy(hospital.id, number.id)
      }
    },
    number
  })
}
